export default {
  __name: 'PrevDaysButton',
  props: {
    isDisabled: {
        type: Boolean,
        default: false,
    },
},
  emits: ['onPreviousDaysClick'],
  setup(__props, { expose, emit }) {
  expose();

const props = __props;



const handleClick = () => {
    emit('onPreviousDaysClick');
};



const __returned__ = { emit, handleClick, props }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

}